import React from 'react';
import './Testimonials.css';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';

const Testimonials: React.FC = () => {
    return (
        <div className="body">
            <Header onSearchClick={() => console.log("Search button clicked")} />
            <div className="parent-container57">
                <div className="container57">
                    <h1>Happily Ever Afters</h1>
                    <p>Read what our happy couples have to say about their experience with 'DateNow'. Their stories will make you believe in the power of true love.</p>
                </div>
            </div>

            <div className="parent-container58">
                <div className="container58">
                    <div className="testimonial-card">
                        <p className="testimonial-text">
                            “I wasn’t really sure what I was looking for when I signed up, but the way conversations naturally started here was different. Less pressure, more curiosity. I ended up connecting with someone completely outside my usual ‘type,’ and honestly, it’s been refreshing. We’re still getting to know each other, but it feels real.”
                        </p>
                        <p className="testimonial-author">– Mia T., Berlin</p>
                    </div>

                    <div className="testimonial-card">
                        <p className="testimonial-text">
                            “What stood out to me was how open-ended everything felt. Not just swiping or judging a few photos — I had space to actually read, reflect, and then reach out. The platform’s still growing, sure, but the energy is good. I’m meeting people who are also here to figure things out without pretending to have all the answers.”
                        </p>
                        <p className="testimonial-author">– Aarav K., Dubai</p>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default Testimonials;
